export const isAuthenticated = (state) => {
    const a = state.auth.auth;
    if (a.accessToken || a.idToken) return true;
    if (a._id) return true;
    if (a.employee && a.employee._id) return true;
    return false;
};
